<template>
  <section class="game-section">
    <div class="section-header">
      <div class="section-title">
        <span class="section-icon">{{ icon }}</span>
        <h2>{{ title }}</h2>
      </div>
      <router-link to="/games" class="see-all-btn">See all</router-link>
    </div>

    <div class="game-grid">
      <GameCard v-for="(game, index) in games" :key="index" :title="game" />
    </div>
  </section>
</template>

<script>
import GameCard from "./gameCard.vue";

export default {
  name: "GameSection",
  components: { GameCard },
  props: {
    title: String,
    icon: String,
    games: Array,
  },
};
</script>

<style scoped>
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
}

.section-icon {
  font-size: 20px;
}

.see-all-btn {
  background: #2a2a2d;
  color: white;
  padding: 0.75rem 14px;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  font-weight: 600;
}

.game-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  justify-items: center;
}

@media only screen and (max-width: 1024px) {
  .game-grid { grid-template-columns: repeat(3, 1fr); }
}
@media only screen and (max-width: 640px) {
  .game-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
